module.exports = __webpack_public_path__ + "media/images/icons/filled/minus-square-15dd9ba2375159fdcd71eb99b8dda44c.svg";